module.exports = {
	"id": "PF",
	"name": "French Polynesia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.012612,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.012612,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.03153,
			"23": null,
			"24": 0.006306,
			"25": 0.06306,
			"26": 0.03153,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.012612,
			"32": 0.012612,
			"33": 0.037836,
			"34": 0.012612,
			"35": 0.03153,
			"36": 0.018918,
			"37": 0.037836,
			"38": 0.018918,
			"39": 0.018918,
			"40": 0.025224,
			"41": 0.088284,
			"42": 0.018918,
			"43": 0.12612,
			"44": 0.056754,
			"45": 0.069366,
			"46": 0.044142,
			"47": 0.03153,
			"48": 0.151344,
			"49": 1.582806,
			"50": 0.037836,
			"51": 0.422502,
			"52": 0.548622,
			"53": 20.299014,
			"54": 5.290734,
			"55": 0.06306,
			"56": 0.012612,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": 0.018918,
			"6": 0.006306,
			"7": null,
			"8": 0.069366,
			"9": 0.012612,
			"10": 0.018918,
			"11": null,
			"12": 0.050448,
			"13": 0.012612,
			"14": null,
			"15": null,
			"16": 0.037836,
			"17": 0.037836,
			"18": null,
			"19": 0.006306,
			"20": 0.012612,
			"21": null,
			"22": null,
			"23": 0.03153,
			"24": 0.006306,
			"25": null,
			"26": 0.025224,
			"27": 0.012612,
			"28": 0.12612,
			"29": 0.012612,
			"30": 0.018918,
			"31": 0.012612,
			"32": 0.088284,
			"33": 0.012612,
			"34": 0.03153,
			"35": 0.006306,
			"36": 0.012612,
			"37": 0.037836,
			"38": 0.296382,
			"39": 0.025224,
			"40": 0.050448,
			"41": 0.069366,
			"42": 0.044142,
			"43": 0.264852,
			"44": 0.050448,
			"45": 0.460338,
			"46": 0.132426,
			"47": 1.153998,
			"48": 1.38732,
			"49": 12.511104,
			"50": 0.069366,
			"51": 0.056754,
			"52": null,
			"3.5": null,
			"3.6": 0.025224
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.012612,
			"37": null,
			"38": 0.012612,
			"39": 0.006306,
			"40": 1.053102,
			"41": 0.151344,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0.025224,
			"5": 0.100896,
			"6": 0.03153,
			"7": 0.069366,
			"8": 0.201792,
			"9": 0.435114,
			"10": 2.547624,
			"3.1": null,
			"3.2": null,
			"5.1": 0.47295,
			"6.1": 0.18918,
			"7.1": 0.025224,
			"9.1": 2.263854
		},
		"ios_saf": {
			"8": 0,
			"10": 6.92159328393,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.18652892985,
			"8.1-8.4": 0.34460429413,
			"9.0-9.2": 0.164398378851,
			"9.3": 2.50812911324
		},
		"android": {
			"3": 0,
			"4": 0.0678187855297,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00847734819121,
			"4.1": 0.244632047804,
			"4.2-4.3": 0.611580119509,
			"4.4": 1.40239560078,
			"4.4.3-4.4.4": 1.41450609819
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.176568,
			"9": 0.088284,
			"10": 0.214404,
			"11": 3.4683,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0152848806896,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000424580019156
		},
		"edge": {
			"12": 0.15765,
			"13": 0.523398,
			"14": 0.983736
		},
		"ie_mob": {
			"10": 0.18574056338,
			"11": 0.75622943662
		},
		"bb": {
			"7": 0.0027705,
			"10": null
		},
		"samsung": {
			"0": 4.218548
		},
		"and_uc": {
			"0": 0.454362
		},
		"op_mini": {
			"0": 0.205930539291
		},
		"and_chr": {
			"0": 19.117564
		},
		"and_ff": {
			"0": 0.14776
		}
	},
	"total": 98.7349345
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/PF.json
 ** module id = 619
 ** module chunks = 0
 **/